import "./clipboard.css";
import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = ["description", "copyIcon", "checkIcon", "label", "button"];

  copy() {
    const text = this.descriptionTarget.innerText.trim();
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedState();
      setTimeout(() => this.resetState(), 2000);
    });
  }

  showCopiedState() {
    this.copyIconTarget.style.display = "none";
    this.checkIconTarget.style.display = "flex";
    this.labelTarget.textContent = "Copié";
    this.buttonTarget.classList.add("Export/Clipboard-button--copied");
  }

  resetState() {
    this.copyIconTarget.style.display = "flex";
    this.checkIconTarget.style.display = "none";
    this.labelTarget.textContent = "Copier";
    this.buttonTarget.classList.remove("Export/Clipboard-button--copied");
  }
}
